export default "__VITE_ASSET__CDU_yxYs__"